import { EqlFieldName } from '@modules/common/constants';
import { EqlField, EqlFieldValueType, ObjectType } from 'generated/graphql';

export const EMPTY_EQL_FIELD_VALUE: EqlField = {
  field: '',
  displayName: '',
  valueType: EqlFieldValueType.String,
  isMultiValue: false,
  objectType: ObjectType.Feedback,
};

export const FEEDBACK_RECORDS_EQL_FIELD: EqlField = {
  __typename: 'EQLField',
  displayName: 'Feedback Records',
  field: EqlFieldName.FeedbackRecords,
  isMultiValue: true,
  objectType: ObjectType.Feedback,
  valueType: EqlFieldValueType.String,
};
